import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice
({
    name: 'user',
    initialState: {
        userAccess: undefined,
        userDetails: null,
        userAccessFailureMessage: undefined,
        access: {
            read: false,
            write: false,
            delete: false,
        }
    },
    reducers: {
        setUser: (state: any, action: any) => {
            state.userDetails = action.payload;
            if(action.payload?.rolePrivilegeData) {
                const access = {
                    read: action.payload?.rolePrivilegeData?.findIndex(priv => priv?.privilegeName === "Read" && priv?.privilegeStatus === "Active") !== -1,
                    write: action.payload?.rolePrivilegeData?.findIndex(priv => priv?.privilegeName === "Write" && priv?.privilegeStatus === "Active") !== -1,
                    delete: action.payload?.rolePrivilegeData?.findIndex(priv => priv?.privilegeName === "Delete" && priv?.privilegeStatus === "Active") !== -1
                }
                state.access = access;
            }
        },
        setUserAccess: (state: any, action: any) => {
            state.userAccess = action.payload;
        },
        setUserAccessFailureMessage: (state: any, action: any) => {
            state.userAccessFailureMessage = action.payload;
        },
    }
})

export const { setUser, setUserAccess, setUserAccessFailureMessage } = userSlice.actions
export const selectUserDetails = (state) => state.user.userDetails;
export default userSlice.reducer;